"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactTableSearch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
var icons_1 = require("../../../icons");
var DebouncedInput = function (_a) {
    var initialValue = _a.value, onChange = _a.onChange, _b = _a.debounce, debounce = _b === void 0 ? 100 : _b, props = __rest(_a, ["value", "onChange", "debounce"]);
    var _c = (0, react_1.useState)(initialValue), value = _c[0], setValue = _c[1];
    (0, react_1.useEffect)(function () {
        setValue(initialValue);
    }, [initialValue]);
    (0, react_1.useEffect)(function () {
        var timeout = setTimeout(function () {
            onChange(value);
        }, debounce);
        return function () { return clearTimeout(timeout); };
    }, [value]);
    return (0, jsx_runtime_1.jsx)(reactstrap_1.Input, __assign({}, props, { value: value, onChange: function (e) { return setValue(e.target.value); } }));
};
// ----------------------------------------------------------------------
var ReactTableSearch = function (_a) {
    var globalFilter = _a.globalFilter, setGlobalFilter = _a.setGlobalFilter;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "d-inline-block" }, { children: (0, jsx_runtime_1.jsxs)(reactstrap_1.InputGroup, __assign({ className: "input-group-merge" }, { children: [(0, jsx_runtime_1.jsx)(DebouncedInput, { className: "form-control-appended", value: globalFilter !== null && globalFilter !== void 0 ? globalFilter : '', onChange: function (value) { return setGlobalFilter(String(value)); }, placeholder: "Search" }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "input-group-append" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "input-group-text" }, { children: (0, jsx_runtime_1.jsx)(icons_1.Search24, {}) })) }))] })) })));
};
exports.ReactTableSearch = ReactTableSearch;
